import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.customer || initialState;

export const selectCustomer = createSelector([selectSlice], state => state);
